var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.current_clinic)?_c('GridHistory'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }